module.exports = function getResource(label, vars = []) {
    const resources = {
        defaultCard: 'Default Card',
        expires: 'Expires',
        payPalAccount: 'PayPal Account',
        payWithPayPal: 'Pay with PayPal',
        payWithApplePay: 'Pay with ApplePay',
        payWithKlarna: `Pay with 4 interest-free payments of ${vars[0]}`,
        payWithAfterpay: `Pay with 4 interest-free payments of ${vars[0]}`,
        storeCreditApplied: 'Account Credit Applied',
        endingIn: 'ending in',
        paymentDisabled: `${vars[0]} cannot be used for Gift Cards, Subscription, or In-store Appointment purchases; with Sephora Credit Card Rewards; or on orders with a total of ${vars[1]} or more.`,
        payPalDisabled: 'PayPal cannot be used when purchasing a subscription.',
        paymentGiftCardMessage: `Gift cards are not combinable with ${vars[0]}. If you want to use a gift card, please select another payment method.`
    };

    return resources[label];
};
